import { AlAggregationFilterContentComponent } from './al-aggregation-filter-content/al-aggregation-filter-content.component';
import { AlArtifactsListComponent } from './al-artifacts-list/al-artifacts-list.component';
import { AlCadenceSelectorComponent } from './al-cadence-selector/al-cadence-selector.component';
import { AlSavedSearchesListComponent } from './al-saved-searches-list/al-saved-searches-list.component';
import { AlSavedSearchesContentComponent } from './al-saved-searches-content/al-saved-searches-content.component';
import { AlSavedSearchesFormComponent } from './al-saved-searches-form/al-saved-searches-form.component';
import { AlNotificationContentComponent } from './al-notification-content/al-notification-content.component';
import { AlNotificationFormComponent } from './al-notification-form/al-notification-form.component';
import { AlNotificationIncidentAlertFormComponent } from './al-notification-incident-alert-form/al-notification-incident-alert-form.component';
import { AlNotificationReportScheduleFormComponent } from './al-notification-report-schedule-form/al-notification-report-schedule-form.component';
import { AlNotificationsListComponent } from './al-notifications-list/al-notifications-list.component';
import { AlScheduleReportFormComponent } from './al-schedule-report-form/al-schedule-report-form.component';
import { AlNotificationHealthAlertFormComponent } from './al-notification-health-alert-form/al-notification-health-alert-form.component';
import { AlScheduleTime, AlScheduleWithDelayComponent } from './al-schedule-with-delay/al-schedule-with-delay.component';
import { AlSetupLinkURLPipe } from './pipes';

const NOTIFICATIONS_COMPONENTS = [
    AlAggregationFilterContentComponent,
    AlArtifactsListComponent,
    AlCadenceSelectorComponent,
    AlSavedSearchesListComponent,
    AlSavedSearchesContentComponent,
    AlSavedSearchesFormComponent,
    AlNotificationIncidentAlertFormComponent,
    AlNotificationsListComponent,
    AlNotificationContentComponent,
    AlSavedSearchesContentComponent,
    AlNotificationFormComponent,
    AlNotificationReportScheduleFormComponent,
    AlScheduleReportFormComponent,
    AlNotificationHealthAlertFormComponent,
    AlScheduleWithDelayComponent,
    AlSetupLinkURLPipe
];

export {
    NOTIFICATIONS_COMPONENTS,
    AlAggregationFilterContentComponent,
    AlArtifactsListComponent,
    AlCadenceSelectorComponent,
    AlSavedSearchesListComponent,
    AlSavedSearchesContentComponent,
    AlSavedSearchesFormComponent,
    AlNotificationIncidentAlertFormComponent,
    AlNotificationsListComponent,
    AlNotificationContentComponent,
    AlNotificationFormComponent,
    AlNotificationReportScheduleFormComponent,
    AlScheduleReportFormComponent,
    AlNotificationHealthAlertFormComponent,
    AlScheduleWithDelayComponent,
    AlScheduleTime,
    AlSetupLinkURLPipe
};
